import { ContentfulType } from 'ContentfulDefaults/ContentfulType';

import { alexGoReviewNote } from './alexGoReviewNote';
import { alexIntro } from './alexIntro';
import { benefits } from './benefits';
import { benefitsAdd } from './benefits_add';
import { benefitsAdditional } from './benefits_additional';
import { benefitsCancer } from './benefits_cancer';
import { benefitsCommuter } from './benefits_commuter';
import { benefitsDCFSA } from './benefits_dcfsa';
import { benefitsDental } from './benefits_dental';
import { benefitsDisability } from './benefits_disability';
import { benefitsHospitalIndemnity } from './benefits_hospital_indemnity';
import { benefitsLife } from './benefits_life';
import { benefitsLtc } from './benefits_ltc';
import { benefitsMedicalFSA } from './benefits_medical_fsa';
import { benefitsPet } from './benefits_pet';
import { benefitsRetirement } from './benefits_retirement';
import { benefitsVision } from './benefits_vision';
import { callToAction } from './callToAction';
import { claimsSummaryBar } from './claimsSummaryBar';
import { customizations } from './customizations';
import { displayName } from './displayName';
import { eligibility } from './eligibility';
import { fbs } from './fbsTokens';
import { health } from './health';
import { healthDetails } from './healthDetails';
import { hsa } from './hsa';
import { logo } from './logo';
import { momentSidebar } from './momentSidebar';
import { navigation } from './navigation';
import { ply } from './ply';
import { profile } from './profile';
import { profileAddtl } from './profileAddtl';
import { review } from './review';
import { spousal } from './spousal';
import { toolTips } from './toolTips';
import { unifiedLanding } from './unifiedLanding';

export function getChineseDefaults(field: keyof ContentfulType) {
  switch (field) {
    case 'top_level_navigation':
      return navigation;
    case 'benefits_section':
      return benefits;
    case 'benefits_section_add':
      return benefitsAdd;
    case 'benefits_section_additional':
      return benefitsAdditional;
    case 'benefits_section_dental':
      return benefitsDental;
    case 'benefits_section_vision':
      return benefitsVision;
    case 'benefits_section_hospital_indemnity':
      return benefitsHospitalIndemnity;
    case 'benefits_section_pet':
      return benefitsPet;
    case 'benefits_section_cancer':
      return benefitsCancer;
    case 'benefits_section_commuter':
      return benefitsCommuter;
    case 'benefits_section_medical_fsa':
      return benefitsMedicalFSA;
    case 'benefits_section_fsa':
      return benefitsDCFSA;
    case 'benefits_section_life':
      return benefitsLife;
    case 'benefits_section_retirement':
      return benefitsRetirement;
    case 'benefits_section_disability':
      return benefitsDisability;
    case 'benefits_section_ltc':
      return benefitsLtc;
    case 'eligibility_section':
      return eligibility;
    case 'health_section':
      return health;
    case 'health_details_section':
      return healthDetails;
    case 'hsa':
      return hsa;
    case 'people_like_you':
      return ply;
    case 'profile_section':
      return profile;
    case 'profile_section_addtl':
      return profileAddtl;
    case 'review_section':
      return review;
    case 'spousal_plan_comparison':
      return spousal;
    case 'tool_tips':
      return toolTips;
    case 'unified_landing_page':
      return unifiedLanding;
    case 'alex_go_review_note':
      return alexGoReviewNote;
    case 'alex_intro_page':
      return alexIntro;
    case 'call_to_action':
      return callToAction;
    case 'claims_summary_bar':
      return claimsSummaryBar;
    case 'plan_customizations':
      return customizations;
    case 'display_name':
      return displayName;
    case 'fbs_tokens':
      return fbs;
    case 'logo':
      return logo;
    case 'moments_that_matter':
      return momentSidebar;
    default:
      return {};
  }
}
